// EmployeeContext.js
import React, { createContext, useState, useEffect } from 'react';

export const EmployeeContext = createContext();

export const EmployeeProvider = ({ children }) => {
  const [employeeName, setEmployeeName] = useState(() => {
    // Retrieve employee name from local storage on component mount
    return localStorage.getItem('employeeName') || '';
  });

  useEffect(() => {
    // Store employee name in local storage whenever it changes
    localStorage.setItem('employeeName', employeeName);
  }, [employeeName]);

  return (
    <EmployeeContext.Provider value={{ employeeName, setEmployeeName }}>
      {children}
    </EmployeeContext.Provider>
  );
};

export const useEmployee = () => {
  const context = React.useContext(EmployeeContext);
  if (!context) {
    throw new Error('useEmployee must be used within an EmployeeProvider');
  }
  return context;
};
